import { t } from "i18next";
import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { debugLogActions } from "../helpers/debugHelper";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";

export const startLoadingStatisticsAdministration = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_STATISTIC}`, "getAdministrator");
    const body = await resp.json();

     debugLogActions(':: statisticActions, startLoadingStatistics', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingStatisticsAdministration(body.administratorStatisticList));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingStatisticsSpecialist = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_STATISTIC}`, "getSpecialist");
    const body = await resp.json();

     debugLogActions(':: statisticActions, startLoadingStatisticsSpecialist', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingStatisticsSpecialist(body.specialistStatisticList));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingStatisticsEndUser = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_STATISTIC}`, "getEndUser");
    const body = await resp.json();

     debugLogActions(':: statisticActions, startLoadingStatisticsEndUser', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingStatisticsEndUser(body.endUserStatisticList));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingStatisticsAdministration = (catalogs) => ({
  type: types.STATISTICS_ADMINISTRATION_LOADING,
  payload: catalogs,
});

const loadingStatisticsSpecialist = (catalogs) => ({
  type: types.STATISTICS_SPECIALIST_LOADING,
  payload: catalogs,
});

const loadingStatisticsEndUser = (catalogs) => ({
  type: types.STATISTICS_END_USER_LOADING,
  payload: catalogs,
});

//1
export const startLoadingGetTopTenCountTextSearchInfoByModule = (id) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_STATISTIC}`, `getTopTenCountTextSearchInfoByModule/${id}`);
    const body = await resp.json();

     debugLogActions(':: statisticActions, startLoadingGetTopTenCountTextSearchInfoByModule', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingGetTopTenCountTextSearchInfoByModule(body.searchInfo));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

//2
export const startLoadingGetTopTenQuantityOfIndicatorsSearchInfoByModule = (id) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_STATISTIC}`, `getTopTenQuantityOfIndicatorsSearchInfoByModule/${id}`);
    const body = await resp.json();

     debugLogActions(':: statisticActions, startLoadingGetTopTenQuantityOfIndicatorsSearchInfoByModule', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingGetTopTenQuantityOfIndicatorsSearchInfoByModule(body.quantityOfIndicatorsSearchInfosResult));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

//3
export const startLoadingGetTopTenQuantityOfFiltersSearchInfoByModule = (id) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_STATISTIC}`, `getTopTenQuantityOfFiltersSearchInfoByModule/${id}`);
    const body = await resp.json();

     debugLogActions(':: statisticActions, startLoadingGetTopTenQuantityOfFiltersSearchInfoByModule', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingGetTopTenQuantityOfFiltersSearchInfoByModule(body.quantityOfFiltersSearchInfosResult));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

//4
export const startLoadingGetTopTenRepetitionsSearchResultByModule = (id) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_STATISTIC}`, `getTopTenRepetitionsSearchResultByModule/${id}`);
    const body = await resp.json();

     debugLogActions(':: statisticActions, startLoadingGetTopTenRepetitionsSearchResultByModule', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingGetTopTenRepetitionsSearchResultByModule(body.repetitionSearchResultList));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};


//5
export const startLoadingGetLastTenLessThan30SearchResultByModule = (id) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_STATISTIC}`, `getLastTenLessThan30SearchResultByModule/${id}`);
    const body = await resp.json();

     debugLogActions(':: statisticActions, startLoadingGetLastTenLessThan30SearchResultByModule', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingGetLastTenLessThan30SearchResultByModule(body.lastTenLessThan30SearchResultsResult));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

//6
export const startLoadingGetTopTenCountSelectedFieldsCompareResultsByModule = (id) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_STATISTIC}`, `getTopTenCountSelectedFieldsCompareResultsByModule/${id}`);
    const body = await resp.json();

     debugLogActions(':: statisticActions, startLoadingGetTopTenCountSelectedFieldsCompareResultsByModule', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingGetTopTenCountSelectedFieldsCompareResultsByModule(body.countSelectedFieldsCompareResultsResult));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};


//7
export const startLoadingGetTopTenRepetitionsCompareResultByModule = (id) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_STATISTIC}`, `getTopTenRepetitionsCompareResultByModule/${id}`);
    const body = await resp.json();

     debugLogActions(':: statisticActions, startLoadingGetTopTenRepetitionsCompareResultByModule', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingGetTopTenRepetitionsCompareResultByModule(body.repetitionCompareResultList));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingGetTopTenCountTextSearchInfoByModule = (statistic) => ({
  type: types.STATISTICS_END_USER_SEARCH_INFO_TEXT_MODULE,
  payload: statistic,
});

const loadingGetTopTenQuantityOfIndicatorsSearchInfoByModule = (statistic) => ({
  type: types.STATISTICS_END_USER_SEARCH_INFO_INDICATORS_MODULE,
  payload: statistic,
});

const loadingGetTopTenQuantityOfFiltersSearchInfoByModule = (statistic) => ({
  type: types.STATISTICS_END_USER_SEARCH_INFO_FILTERS_MODULE,
  payload: statistic,
});

const loadingGetTopTenRepetitionsSearchResultByModule = (statistic) => ({
  type: types.STATISTICS_END_USER_SEARCH_RESULT_REPETITIONS_MODULE,
  payload: statistic,
});

const loadingGetLastTenLessThan30SearchResultByModule = (statistic) => ({
  type: types.STATISTICS_END_USER_SEARCH_RESULT_LESS30_MODULE,
  payload: statistic,
});

const loadingGetTopTenCountSelectedFieldsCompareResultsByModule = (statistic) => ({
  type: types.STATISTICS_END_USER_COMPARE_RESULT_FIELDS_MODULE,
  payload: statistic,
});

const loadingGetTopTenRepetitionsCompareResultByModule = (statistic) => ({
  type: types.STATISTICS_END_USER_COMPARE_RESULT_REPETITION_MODULE,
  payload: statistic,
});

export const cleanStatisticsListsByModule = () => ({
  type: types.STATISTIC_END_USER_CLEAN_STATS,
});

const buildIntentionsQuery = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.set(key, value);
    }
  });
  const qs = params.toString();
  return qs ? `?${qs}` : '';
};

export const startLoadingIntentionStatistics = (filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: types.STATISTICS_INTENTIONS_SET_LOADING, payload: true });
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_STATISTIC}`,
        `getIntentions${buildIntentionsQuery(filters)}`
      );
      const body = await resp.json();
      if (body.ok) {
        dispatch({
          type: types.STATISTICS_INTENTIONS_LOADING,
          payload: {
            demandByModule: body.demandByModule || [],
            topRequested: body.topRequested || [],
            topViewed: body.topViewed || [],
            searchToTargets: body.searchToTargets || [],
            funnel: body.funnel || {},
            daily: body.daily || [],
            from: body.from,
            to: body.to,
            module_key: body.module_key,
          },
        });
      } else {
        dispatch({ type: types.STATISTICS_INTENTIONS_SET_LOADING, payload: false });
        if (body.code === "bak-error-001") {
          Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method || ''}`, "error");
        }
        if (body.code === "bak-aut-tok-inv-001") {
          Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002" || body.code === "bak-aut-tok-001" || body.code === "bak-aut-tok-002") {
          Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
          dispatch(startLogout());
        }
        if (!body.code) {
          Swal.fire(t("titles.error"), body.msg || t("alerts.validation.bak-error-001"), "error");
        }
      }
      return body;
    } catch (error) {
      dispatch({ type: types.STATISTICS_INTENTIONS_SET_LOADING, payload: false });
      Swal.fire(t("titles.error"), String(error), "error");
      return { ok: false, msg: String(error) };
    }
  };
};

const handleStatAuth = (dispatch, body) => {
  if (!body || body.ok) return false;
  if (body.code === "bak-cfg-disabled") {
    return true;
  }
  if (body.code === "bak-error-001") {
    Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method || ''}`, "error");
  }
  if (body.code === "bak-aut-tok-inv-001") {
    Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
    dispatch(startLogout());
  }
  if (body.code === "bak-aut-tok-inv-002" || body.code === "bak-aut-tok-001" || body.code === "bak-aut-tok-002") {
    Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
    dispatch(startLogout());
  }
  return true;
};

export const startLoadingPlatformHealth = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_STATISTIC}`, "getPlatformHealth");
    const body = await resp.json();
    if (body.ok) {
      dispatch({ type: types.STATISTICS_HEALTH_LOADING, payload: body });
    } else {
      handleStatAuth(dispatch, body);
    }
    return body;
  };
};

export const startSearchingJourneyUsers = (filters = {}) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_STATISTIC}`,
      `searchJourneyUsers${buildIntentionsQuery(filters)}`
    );
    const body = await resp.json();
    if (!body.ok) {
      handleStatAuth(dispatch, body);
      if (!body.code) {
        Swal.fire(t("titles.error"), body.msg || t("alerts.validation.bak-error-001"), "error");
      }
    }
    return body;
  };
};

export const startLoadingUserJourney = (filters = {}) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_STATISTIC}`,
      `getUserJourney${buildIntentionsQuery(filters)}`
    );
    const body = await resp.json();
    if (body.ok) {
      dispatch({ type: types.STATISTICS_JOURNEY_LOADING, payload: body });
    } else {
      handleStatAuth(dispatch, body);
      if (!body.code) {
        Swal.fire(t("titles.error"), body.msg || t("alerts.validation.bak-error-001"), "error");
      }
    }
    return body;
  };
};

export const startLoadingSearchTrends = (filters = {}) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_STATISTIC}`,
      `getSearchTrends${buildIntentionsQuery(filters)}`
    );
    const body = await resp.json();
    if (body.ok) {
      dispatch({ type: types.STATISTICS_TRENDS_LOADING, payload: body });
    } else {
      handleStatAuth(dispatch, body);
    }
    return body;
  };
};

export const startLoadingExploreFeed = (filters = {}) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_STATISTIC}`,
      `getExploreFeed${buildIntentionsQuery(filters)}`
    );
    const body = await resp.json();
    if (body.ok) {
      dispatch({ type: types.STATISTICS_EXPLORE_LOADING, payload: body });
    } else {
      handleStatAuth(dispatch, body);
    }
    return body;
  };
};

export const startLoadingEndUserActivity = () => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_STATISTIC}`,
      "getEndUserActivity"
    );
    const body = await resp.json();
    if (body.ok) {
      dispatch({ type: types.STATISTICS_END_USER_ACTIVITY_LOADING, payload: body.activity });
    } else {
      handleStatAuth(dispatch, body);
    }
    return body;
  };
};

export const startLoadingFlowEngineStatistics = () => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_STATISTIC}`,
      "getFlowEngine"
    );
    const body = await resp.json();
    if (body.ok) {
      dispatch({ type: types.STATISTICS_FLOW_ENGINE_LOADING, payload: body.reports });
    } else {
      handleStatAuth(dispatch, body);
    }
    return body;
  };
};


